<div class="grid grid-cols-1 md:grid-cols-2 gap-8">
  <ng-container *ngFor="let field of specFields; let i = index">
    <div class="mb-6">
      <label class="block text-xs font-semibold mb-1">{{ field.label }}</label>
      <ng-container *ngFor="let ctrl of getSpecArray(field.key).controls; let j = index">
        <div class="flex items-center gap-2 mb-2">
          <mat-form-field appearance="fill" class="flex-1">
            <input
              matInput
              [formControl]="getSpecFormControl(field.key, j)"
              [placeholder]="field.label"
              [readonly]="readonly && field.key !== 'putUp' && field.key !== 'supplier'"
              (click)="onReadonlyClick($event, field.key)"
            />
          </mat-form-field>
          <button
            mat-icon-button
            color="primary"
            type="button"
            (click)="onAddFieldClick($event, field.key)"
            *ngIf="j === getSpecArray(field.key).length - 1 && !viewDisable"
          >
            <mat-icon>add</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            type="button"
            (click)="onRemoveFieldClick($event, field.key, j)"
            *ngIf="getSpecArray(field.key).length > 1 && !viewDisable"
          >
            <mat-icon>remove</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
